(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/game-launcher.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/leia/game-launcher.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components,
  GameLauncherLeia = _svs$ticketgames$tick.GameLauncherLeia,
  GameWrapper = _svs$ticketgames$tick.GameWrapper,
  TopBar = _svs$ticketgames$tick.TopBar,
  Receipt = _svs$ticketgames$tick.Receipt,
  LoaderTicket = _svs$ticketgames$tick.LoaderTicket,
  TicketIdPopper = _svs$ticketgames$tick.TicketIdPopper;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  resizeFromFullscreen = _svs$ticketgames$tick2.resizeFromFullscreen,
  resizeFromTicketInfo = _svs$ticketgames$tick2.resizeFromTicketInfo,
  defaultEventsLeiaFactory = _svs$ticketgames$tick2.defaultEventsLeiaFactory,
  tracking = _svs$ticketgames$tick2.tracking;
const _svs$eInstant$lobby$p = svs.eInstant.lobby.play.leia,
  _svs$eInstant$lobby$p2 = _svs$eInstant$lobby$p.ticketEvents,
  GAME_LOADING = _svs$eInstant$lobby$p2.GAME_LOADING,
  HAS_CLAIMED = _svs$eInstant$lobby$p2.HAS_CLAIMED,
  HAS_BET = _svs$eInstant$lobby$p2.HAS_BET,
  TAG = _svs$eInstant$lobby$p2.TAG,
  customNotifiers = _svs$eInstant$lobby$p.customNotifiers;
const gameEngineCode = svs.ticketgames.ticketUtility.utils.constants.leia.gameEngineCode;
const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer,
  useMemo = _React.useMemo;
const matchPath = svs.app.ReactRouter.matchPath;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const getCloseUrl = () => {
  var _svs$utils$paramHandl;
  const _svs$eInstant$constan = svs.eInstant.constants.ROUTES,
    ALL_GAMES_INFO = _svs$eInstant$constan.ALL_GAMES_INFO,
    ALL_GAMES = _svs$eInstant$constan.ALL_GAMES,
    CATEGORY = _svs$eInstant$constan.CATEGORY,
    CATEGORY_INFO = _svs$eInstant$constan.CATEGORY_INFO,
    INFO = _svs$eInstant$constan.INFO,
    LOBBY = _svs$eInstant$constan.LOBBY;
  const returnUrlParam = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
    key: 'returnUrl'
  })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
  const returnUrl = returnUrlParam && decodeURIComponent(returnUrlParam);
  if (!returnUrl) return {
    url: LOBBY,
    match: null
  };
  let match;
  for (const route of [ALL_GAMES_INFO, ALL_GAMES, CATEGORY, CATEGORY_INFO, INFO]) {
    const path = "".concat(svs.core.data.baseUrl).concat(route);
    match = matchPath(returnUrl, {
      path,
      exact: true
    });
    if (match) break;
  }
  return {
    url: match ? returnUrl.replace(svs.core.data.baseUrl, '') : svs.eInstant.constants.ROUTES.LOBBY,
    match
  };
};
const GameLauncher = () => {
  var _wager$properties;
  const _ReactRouterDOM = ReactRouterDOM,
    useHistory = _ReactRouterDOM.useHistory;
  const history = useHistory();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fullScreenMargin = _useState2[0],
    setFullScreenMargin = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    wrapperSize = _useState4[0],
    setWrapperSize = _useState4[1];
  const _svs$eInstant$store = svs.eInstant.store,
    UPDATE_CATEGORIES = _svs$eInstant$store.actions.UPDATE_CATEGORIES,
    RouterContext = _svs$eInstant$store.RouterContext;
  const _useContext = useContext(svs.eInstant.lobby.play.PlayContext),
    wager = _useContext.wager,
    isDemo = _useContext.isDemo,
    ticketInfo = _useContext.ticketInfo;
  const _ref = useContext(RouterContext) || {
      dispatch: () => {},
      state: {
        categories: []
      }
    },
    routerDispatch = _ref.dispatch,
    categories = _ref.state.categories;
  const GAME_URL = svs.eInstant.store.actions.GAME_URL;
  const useCustomEvents = svs.eInstant.lobby.play.leia.useCustomEvents;
  const _svs$eInstant$lobby$p3 = svs.eInstant.lobby.play.utils,
    hideFooter = _svs$eInstant$lobby$p3.hideFooter,
    showFooter = _svs$eInstant$lobby$p3.showFooter;
  const wagerId = wager === null || wager === void 0 || (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalWagerId;
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  const gameAvailable = Boolean(wager) || ticketInfo.open;
  const betId = [gameEngineCode.VEIKKAUS, gameEngineCode.NEO].includes(ticketInfo.gameEngineCode) ? wagerId === null || wagerId === void 0 ? void 0 : wagerId.replace('/LEA', '') : parseInt(wagerId, 10);
  const _useReducer = useReducer(reducer, {
      isDemo,
      ticketInfo,
      wager,
      betId,
      isEInstant: true,
      isFullScreenGame
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  const onClose = function () {
    var _match$params;
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref2.name;
    let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$isCompleted = _ref3.isCompleted,
      isCompleted = _ref3$isCompleted === void 0 ? false : _ref3$isCompleted,
      winAmount = _ref3.winAmount,
      anchorId = _ref3.anchorId;
    if (!isCompleted) {
      tracking.trackTopBarActionQualtrics(name, winAmount);
    }
    const _getCloseUrl = getCloseUrl(),
      url = _getCloseUrl.url,
      match = _getCloseUrl.match;
    (match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.gameId) && routerDispatch({
      type: GAME_URL,
      payload: {
        gameUrl: match.params.gameId
      }
    });
    history === null || history === void 0 || history.push(anchorId ? "".concat(url, "#").concat(anchorId) : url);
  };
  const updateCategories = () => {
    const newCategories = categories === null || categories === void 0 ? void 0 : categories.reduce((list, category) => {
      var _category$gameList;
      let c = category;
      if ((_category$gameList = category.gameList) !== null && _category$gameList !== void 0 && (_category$gameList = _category$gameList.config) !== null && _category$gameList !== void 0 && _category$gameList.lastPlayedTickets) {
        const newGames = [...category.games].filter(_ref4 => {
          let type = _ref4.type;
          return type !== ticketInfo.type;
        });
        c = _objectSpread(_objectSpread({}, category), {}, {
          games: [ticketInfo, ...newGames]
        });
      }
      list.push(c);
      return list;
    }, []);
    routerDispatch({
      type: UPDATE_CATEGORIES,
      payload: {
        categories: newCategories
      }
    });
  };
  const onPlay = () => {
    history.push(ticketInfo.playUrl);
  };
  const _useCustomEvents = useCustomEvents({
      ticketInfo,
      wager,
      isDemo,
      onClose,
      onPlay,
      dispatch,
      updateCategories
    }),
    handleGameLoaded = _useCustomEvents.handleGameLoaded,
    handleOngoingGame = _useCustomEvents.handleOngoingGame,
    handleHasClaimed = _useCustomEvents.handleHasClaimed,
    isLoading = _useCustomEvents.isLoading,
    getLastWonAmount = _useCustomEvents.getLastWonAmount,
    shouldShowPlayAgain = _useCustomEvents.shouldShowPlayAgain,
    handleHasBet = _useCustomEvents.handleHasBet;
  const _svs$ticketgames$tick3 = svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus({
      ticketInfo
    }),
    soundStatus = _svs$ticketgames$tick3.soundStatus,
    notifySoundStatus = _svs$ticketgames$tick3.notifySoundStatus,
    soundEvents = _svs$ticketgames$tick3.soundEvents;
  const shouldShowReceipt = !isLoading && (wager === null || wager === void 0 ? void 0 : wager.completed);
  useEffect(() => {
    const defaultEventsLeia = defaultEventsLeiaFactory({
      ticketInfo,
      isDemo,
      isEInstant: true,
      isReplay: wager === null || wager === void 0 ? void 0 : wager.completed,
      onClose: () => {
        var _match$params2;
        const _getCloseUrl2 = getCloseUrl(routerDispatch),
          url = _getCloseUrl2.url,
          match = _getCloseUrl2.match;
        if (match !== null && match !== void 0 && (_match$params2 = match.params) !== null && _match$params2 !== void 0 && _match$params2.gameId) {
          routerDispatch({
            type: GAME_URL,
            payload: {
              gameUrl: match.params.gameId
            }
          });
        }
        history === null || history === void 0 || history.push(url);
      }
    });
    const customEvents = [{
      eventName: GAME_LOADING,
      handler: handleGameLoaded
    }, {
      eventName: TAG,
      handler: handleOngoingGame
    }, {
      eventName: HAS_CLAIMED,
      handler: handleHasClaimed
    }, {
      eventName: HAS_BET,
      handler: handleHasBet
    }];

    const _svs$eInstant$lobby$p4 = svs.eInstant.lobby.play.leia.eventHandler(ticketInfo.gameLoader, [...defaultEventsLeia, ...customEvents, ...soundEvents]),
      initialize = _svs$eInstant$lobby$p4.initialize,
      destroy = _svs$eInstant$lobby$p4.destroy;
    initialize();
    if (!gameAvailable) {
      svs.ticketgames.ticketUtility.utils.showGameClosedDialog({
        isDemo,
        onClose,
        gameCode: ticketInfo.type || ticketInfo.name
      });
    }
    hideFooter();
    return () => {
      svs.eInstant.lobby.play.utils.removeBreakPointListeners();
      destroy();
      showFooter();
    };
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const handleSoundClick = useCallback(soundStatus => {
    const loaderType = ticketInfo.gameLoader.toUpperCase();
    const setSoundStatus = customNotifiers.soundStatus[loaderType] || notifySoundStatus;
    setSoundStatus(soundStatus);
  }, [notifySoundStatus, ticketInfo]);
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  return gameAvailable ? React.createElement("div", {
    className: "".concat(!isFullScreenGame ? 'padding-v-2' : ''),
    id: "einstant-game-launcher"
  }, React.createElement(GameWrapper, {
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      svs.ticketgames.ticketUtility.utils.showDialog({
        type: 'close',
        isDemo,
        onClose: () => {
          onClose(ticketInfo, {
            isCompleted: wager === null || wager === void 0 ? void 0 : wager.completed,
            isDemo,
            winAmount: getLastWonAmount()
          });
        }
      });
    },
    onSoundClick: () => {
      handleSoundClick(!soundStatus);
    },
    trackingLabel: tracking.createTopBarTrackingLabel({
      isDemo,
      location: wager ? 'mina-spel' : 'spela',
      gameCode: ticketInfo.type
    })
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, null), isLoading && React.createElement(LoaderTicket, null))), shouldShowReceipt && React.createElement(Receipt, {
    fetchedGame: wager,
    style: {
      opacity: 0
    },
    ticketInfo: ticketInfo
  }), shouldShowPlayAgain && React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Spela igen',
      onClick: onPlay
    }],
    isFixed: true
  })) : React.createElement("div", null);
};
setGlobal('svs.eInstant.lobby.play.leia.GameLauncher', GameLauncher);

 })(window);